export default __webpack_public_path__ + "static/media/logo.1fb7ba55.svg";